jQuery(document).ready(function($){

	/*
	 * Custom carousel v headeru
	*/
	var Carousel = {
		wrap: $('#jq-hero-carousel'),
		actualPage: 0,
		timeout: 8500
	};

	Carousel.init = function() {
		Carousel.items = Carousel.wrap.find('.hero-carousel__item');
		Carousel.itemsTotal = Carousel.items.length;
		Carousel.texts = Carousel.wrap.find('.hero-carousel__text');
		Carousel.interval = null;

		// vytvoří stránkovač
		var pageItems = '';
		for (var i = 0; i < Carousel.itemsTotal; i++) {
			pageItems += '<div class="hero-carousel__page" data-pageindex="' + i + '"></div>';
		}
		Carousel.wrap.find('.hero-carousel__pages').html(pageItems);
		Carousel.pages = Carousel.wrap.find('.hero-carousel__page');

		Carousel.pages.click(function(){
			var newPage = parseInt($(this).data('pageindex'));

			if (newPage != Carousel.actualPage) {
				clearInterval(Carousel.interval);
				Carousel.interval = setInterval(Carousel.moveNext, Carousel.timeout);
				Carousel.changePage(newPage);
			}
		});

		$(Carousel.pages[0]).addClass('hero-carousel__page--active');
		$(Carousel.items[0]).addClass('hero-carousel__item--active');
		$(Carousel.texts[0]).addClass('hero-carousel__text--active');
		Carousel.interval = setInterval(Carousel.moveNext, Carousel.timeout);
		setTimeout(function(){ Carousel.wrap.addClass('hero-carousel--ready'); }, 10);

		Carousel.wrap.find('.hero-carousel__next').click(function(){
			clearInterval(Carousel.interval);
			Carousel.interval = setInterval(Carousel.moveNext, Carousel.timeout);
			Carousel.moveNext();
		});
	};


	Carousel.changePage = function(newPage) {
		var actualPage = Carousel.actualPage;

		$(Carousel.items[actualPage]).removeClass('hero-carousel__item--active');
		$(Carousel.items[newPage]).addClass('hero-carousel__item--active');
		$(Carousel.texts[actualPage]).removeClass('hero-carousel__text--active');
		$(Carousel.texts[newPage]).addClass('hero-carousel__text--active');
		$(Carousel.pages[actualPage]).removeClass('hero-carousel__page--active');
		$(Carousel.pages[newPage]).addClass('hero-carousel__page--active');

		Carousel.actualPage = newPage;
	};

	Carousel.moveNext = function() {
		var newPage = Carousel.actualPage + 1;
		newPage = newPage < Carousel.itemsTotal ? newPage : 0;
		Carousel.changePage(newPage);
	}

	Carousel.destroy = function() {
		clearInterval(Carousel.interval);
	}

	if (Carousel.wrap.length == 1)
		Carousel.init();

});